import React, { useEffect } from 'react';
import { Header, useUserInfoStore } from '@pascal/pascal-core';
import { GameControllerTypes } from '@pascal/pascal-core/table-line/t_types/enums/GameControllerTypes';
import { Settings } from '@pascal/pascal-core/table-line';
import { BetHistoryWr } from '../betHistory';
import { HelpPopup } from '../../components/helpPopup';
import { observer } from 'mobx-react-lite';
import { tableBetHistoryStore } from '@pascal/pascal-core/shared/core/store/tableBetHistoryStore';
import { videoInfoStore } from '../../store/videoInfoStore';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';

export const HeaderWr = observer(() => {
  const { setSelectedHistoryRow, selectedHistoryRow } = tableBetHistoryStore;
  const { isVideoAuto, setIsVideoVertical, isVideoVertical, setIsVideoAuto } = videoInfoStore;
  const { isSkipLobby } = gameConfigStore;

  const { currencyCode } = useUserInfoStore();
  useEffect(() => {
    return () => {
      setIsVideoAuto(true);
      setIsVideoVertical(false);
    };
  }, []);

  return (
    <Header
      currencyCode={currencyCode}
      lobbyPath={isSkipLobby ? null : '/'}
      isVideo={true}
      videoClassName={isVideoAuto ? '' : isVideoVertical ? 'type-2' : 'type-1'}
      onToggleVideo={() => {
        if (isVideoAuto) {
          setIsVideoAuto(false);
          setIsVideoVertical(true);
        } else if (isVideoVertical) {
          setIsVideoVertical(false);
        } else {
          setIsVideoAuto(true);
        }
      }}
      selectedHistoryRow={selectedHistoryRow}
      setSelectedHistoryRow={setSelectedHistoryRow}
      gameControllerComponents={{
        [GameControllerTypes.Help]: <HelpPopup />,
        [GameControllerTypes.History]: <BetHistoryWr />,
        [GameControllerTypes.Settings]: <Settings isMusicOn />,
      }}
    />
  );
});
